import React from "react";
import Layout from "layouts";
import PieOfTheMonthAddComponent from "./details/PieOfTheMonthAddComponent";

export default function PieOfTheMonth() {
  return (
    <Layout breadCrumb={[{ label: "Pie of the Month", to: "#" }]}>
      <PieOfTheMonthAddComponent />
    </Layout>
  );
}
